export const AccountTypeFactory = () => {
    return function AccountType() {
        this.id = null;
        this.name = null;
    };
};
